import React from 'react';
var BopIcon = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-building2 w-5 h-5 text-orange-600 dark:text-orange-400" },
        React.createElement("path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" }),
        React.createElement("path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" }),
        React.createElement("path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" }),
        React.createElement("path", { d: "M10 6h4" }),
        React.createElement("path", { d: "M10 10h4" }),
        React.createElement("path", { d: "M10 14h4" }),
        React.createElement("path", { d: "M10 18h4" })));
};
export default BopIcon;
